import { Component, OnInit, ViewChild } from '@angular/core';
import { HeaderData } from 'src/app/_models/header-data';
import { DiceService } from '../_services/dice.service';
import { Router, ActivatedRoute } from '@angular/router';
import { DICE_QUOTES_CONFIG } from '../../_common/product-config';
import { StatusCode, QuoteStatus, LobStatus, DiceQuoteTypes, NewBusiness, HiredorBorrowedPD, AddressType, WOS, YesNo, LobCodes } from 'src/app/_common/_enum/module.enum';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-view-quote',
  templateUrl: './view-quote.component.html',
  styleUrls: ['./view-quote.component.scss']
})
export class ViewQuoteComponent implements OnInit {
  private headerData:HeaderData;

  private wos = WOS;
  private yesNoEnum = YesNo;

  private quotekeys: any = {
    applicationId: '',
    quoteId: ''
  };

  private selectedItem = 'quotedetails';

  private quoteResponse: any;
  private quote: any;
  private application: any;

  private businessAddress;
  private mailingAddress;
  private billingAddress;

  private addressTypeEnum = AddressType;
  private diceConfig = DICE_QUOTES_CONFIG;
  private quoteStatusEnum = QuoteStatus;
  private lobStatusEnum = LobStatus;
  private lobCodes = LobCodes;
  private hiredorBorrowedPDenum = HiredorBorrowedPD.HiredorBorrowedPDConst;

  private loading: boolean = false;
  private downloadingDocument: any = [];
  private isActivityExistInProduction: boolean = false;
  private activities: any;
  private uniqueLobs: any;
  private _dnbEventModel: any;


  /**** Child View for All Modals ****/
  @ViewChild("quoteDocumentsModal", {static: false}) quoteDocumentsModal;
  glOccurrenceDisplayVal: any;

  constructor(private diceService: DiceService, private router: Router, private route: ActivatedRoute) { }

  ngOnInit() {
    this.headerData = new HeaderData();
    console.log(this.lobStatusEnum);

    this.fetchQuoteDetails();
  }

  
  setHeaderData(details?: any){
    this.headerData.pageTitle = "DICE Quote";

    if(details){
      let pipe = new DatePipe('en-US');
      this.headerData.detailMenu = [{label: "Created", description: pipe.transform(this.quote.policyCreatedDate, 'MM/dd/yyyy')}, {label: "Effective Date", description: pipe.transform(this.quote.policyEffectiveDate, 'MM/dd/yyyy', 'UTC')}];
    }

    this.diceService.header = this.headerData;
  }

  /*** Gets Application Key and Quote ID from URL Route / State Params  ***/
  getAppKeyandQuoteId() {
    this.route.paramMap.subscribe(params => {
      this.quotekeys.applicationId = params.get('key').toString();
      this.quotekeys.quoteId = params.get("id").toString();

      console.log("QuoteKeys :: ", this.quotekeys);
    });
  }

  fetchQuoteDetails(){
    this.getAppKeyandQuoteId();
    this.loading = true;
    let quoteDetailsSubscription = this.diceService.fetchQuoteDetails(this.quotekeys).subscribe(response => {
      this.loading = false;
      this.quoteResponse = response;

      this.quote = this.quoteResponse.quoteDetails;
      this.application = this.quoteResponse.application;

      this.retrieveAddresses();
      this.updateGLDipslayForOccurrenceField();
      this.checkIfActivityExisits();
      this.setHeaderData(this.quote);
      this.viewUniquePolicyNumbers();

      console.log("View Details - _isdnbevent :: ", history.state.isDnBEvent);
      if(history && history.state && history.state.isNewQuote) {
        console.log(history.state.dnbEventModel);
        this._dnbEventModel = history.state.dnbEventModel;
        this._dnbEventModel.accountNumber = this.quote.accountNumber !== 0 ? this.quote.accountNumber : null;
        console.log('this._dnbEventModel :: ', this._dnbEventModel);
        this.diceService.dnbEventLog(this._dnbEventModel);
      }
    });

    this.diceService.runningServices.push(quoteDetailsSubscription);
  }

  getAddress(_type){
    return this.application.addresses.find(_address=> {return _address.addressType == _type});
  }

  retrieveAddresses(){
    this.businessAddress = this.getAddress(this.addressTypeEnum.Business);
    if(this.getAddress(this.addressTypeEnum.Mailing)){ this.mailingAddress = this.getAddress(this.addressTypeEnum.Mailing); }
    else { this.mailingAddress = this.businessAddress; }
    if(this.getAddress(this.addressTypeEnum.Billing)){ this.billingAddress = this.getAddress(this.addressTypeEnum.Billing) }
    else { this.billingAddress = this.mailingAddress; }
  }

  updateGLDipslayForOccurrenceField() {
    this.glOccurrenceDisplayVal = this.application.coverage.loBs[0].options[0].selectedOptions[0].value.split(' ');
    console.log('this.glOccurrenceDisplayVal :: ', this.glOccurrenceDisplayVal);
  }

  checkIfActivityExisits() {
    if(this.application) {
      let questionLength = this.application.questionAnswers.length;
      this.isActivityExistInProduction = (this.application.questionAnswers[questionLength - 1].answer === this.yesNoEnum.YES);
    }
  }

  setdocsAvailableFlag() {
    if(this.quote) {
      this.quote.lobsPremium.forEach(lob => {
        lob.docsAvailable = true;
      });
    }
  }

  viewPolicyDocumentsModal() {
    this.setdocsAvailableFlag();
    console.log('quote.lobsPremium :: ', this.quote.lobsPremium);
    this.diceService.openModal('none', this.quoteDocumentsModal, true, 'light-blue-backdrop', 'static', 'documentsListModal');
  }

  viewUniquePolicyNumbers () {
    console.log(this.quote.lobsPremium);
    this.uniqueLobs;

    this.uniqueLobs = this.quote.lobsPremium.filter((v, i) => this.quote.lobsPremium.findIndex(item => (item.type === v.type && item.lobStatus === this.lobStatusEnum.Quoted)) === i);
    console.log('uniqueLobType :: ', this.uniqueLobs);
  }

  downloadQuote(_lob, idx) {
    let documentDts = {
      accountNumber: this.quote.accountNumber,
      quoteName: this.quote.quoteName,
      productInstanceID: _lob.documentProductNumber   // documentProductNumber -  is product instance id
    } 
    this.downloadingDocument[idx] = true;

    let downloadDocumentsSubscription = this.diceService.downloadDocuments(_lob.type + " Quote", documentDts).subscribe(data => {
      this.downloadingDocument[idx] = false;

      /*** If the policy document is not available it will display message on modal ***/
      if(data){
        _lob.docsAvailable = true;
      }
      else {
        _lob.docsAvailable = false;
      }

      console.log("_lob.docsAvailable :: ", _lob.docsAvailable);
    },
    error => {
      console.log("Download Failed");
      this.downloadingDocument[idx] = false;

      let hasOpenModals = this.diceService.hasOpenModals();
      if (hasOpenModals) {
        this.diceService.closeModal();
      }
      
      if(error.status == StatusCode.InternalServer) {
        setTimeout(() => {
          this.diceService.openModal('error', 'none', false, 'light-blue-backdrop', false, '');
        }, 50);
      }
      console.warn("Download Policy Documents Failed!!  : " + error);
    });

    this.diceService.runningServices.push(downloadDocumentsSubscription);
  }

  gotoUrl(_url) {
    this.router.navigate([_url], {state: {selectedBusiness: NewBusiness.DICE}});
  }
  
  copyQuote(_appId, _quoteId) {
    let _quoteDetails = {
      diceQuoteType: DiceQuoteTypes.Copy,
      applicationId: _appId,
      quoteId: _quoteId
    };
    console.log('_quoteDetails - listscreen :: ', _quoteDetails);
    this.router.navigate(["newbusiness/dice/create"], {state: {diceQuoteDetails: _quoteDetails}});
  }

  bindnissue(_url, appKey, quoteId) {
    this.router.navigateByUrl("newbusiness/dice/"+ _url + "/" + appKey + "/" + quoteId);
  }

  /* updateFeinNumberView(_feinNumber){
    if(_feinNumber){
     if(_feinNumber.indexOf("-") > -1){
      this.application.accountFein = _feinNumber;
     }else{
      this.application.accountFein = _feinNumber.substr(0,2) + '-' + _feinNumber.substr(2, _feinNumber.length);
     }
    }else{
      this.application.accountFein = null;
    }
  } */

  ngOnDestroy() {
    this.diceService.runningServices.forEach(subscription => subscription.unsubscribe());
  }
}
